<template>
    <div
        class="ird-card gcmcn-card"
        :class="{'selected-element' : selectedIrdUid === ird.uid}"
        @click="showIrdDetails"
    >
        <div>
            <span class="ird-name">{{ ird.name }}</span>
            <div>{{ entity.display_name }} | {{ takerName }}</div>
        </div>
        <i
            class="el-icon-arrow-right selection-arrow"
            :class="{'rotate-icon-arrow' : selectedIrdUid === ird.uid}"
        ></i>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {

    components: {

    },

    props: {
        ird: {
            type: Object,
            required: true
        },
        selectedIrdUid: {
            type: String,
            required: true
        },
    },

    data: function(){
        return {
        };
    },

    computed: {
        ...mapGetters([
            'entitiesByUid',
            'takersByUid'
        ]),
        entity() {
            return this.entitiesByUid(this.ird.scopes.entity_uid);
        },
        takerName(){
            return this.takersByUid(this.ird.taker_uid).name;
        },
    },

    mounted: function(){
    },

    methods: {
        showIrdDetails() {
            this.$emit('change-selected-ird', this.ird.uid);
        }
    },
};
</script>

<style lang="scss">
.ird-card {
    display: flex;
    position: relative;
    cursor: pointer;
    .ird-name{
        font-weight: bold;
    }
    +.ird-card {
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Receiver/Ird/irdCard.vue